import Vue from 'vue';
import Router from 'vue-router';
import AuthService from '@/service/auth/authService';
import Dashboard from '@/views/Dashboard.vue';
import Home from '@/views/Home.vue';
import NotFound from '@/views/404.vue';
import Applicants from '@/views/Applicants.vue';
import PrintApplicantProfile from '@/views/PrintApplicantProfile.vue';
import ForgotPassword from '@/views/ForgotPassword.vue';
import ResetPassword from '@/views/ResetPassword.vue';
import SetPassword from '@/views/SetPassword.vue';
import Setting from '@/views/Setting.vue';
import SearchTemplates from '@/views/SearchTemplates.vue';
import Agreement from '@/views/Agreement.vue';
import Logout from '@/components/Logout.vue';
import Users from '@/components/users/Users.vue';
import CreateUser from '@/components/users/CreateUser.vue';
import ViewApplicantProfile from './views/ViewApplicantProfile';
import ReviewList from './components/dashboard/reviewList/ReviewList';
import CreateReviewList from './components/dashboard/reviewList/CreateReviewList';
import ApplicantPreview from './components/dashboard/applicantsPreview/ApplicantPreview.vue';
// import OccupationList from "./components/dashboard/occupationList/OccupationList.vue";
import ChangePassword from './components/auth/ChangePassword.vue';
import IndividualContact from './components/dashboard/contacts/IndividualContact.vue';
import ReceivedContactLists from './components/dashboard/contacts/contactLists/ReceivedContactLists.vue';
import ContactList from './components/dashboard/contacts/contactLists/ContactLists.vue';
import SentContactList from './components/dashboard/contacts/contactLists/SentContactList.vue';
import MessageTemplate from './components/dashboard/contacts/MessageTemplate/MessageTemplate.vue';
import ModifyMessageTemplate from './components/dashboard/contacts/MessageTemplate/ModifyMessageTemplate.vue';
import JobDescriptionList from './components/dashboard/jobDescription/JobDescriptionList.vue';
import JobMatching from './components/dashboard/jobDescription/JobMatching.vue';
// import JDMenu from './components/dashboard/jobDescription/JDMenu.vue';
// import JDFilter from './components/dashboard/jobDescription/JDFilter.vue';
import JDMatchingList from './components/dashboard/jobDescription/JDMatchingList.vue';
import ScoutApplicants from './views/ScoutApplicants.vue';
import TwoFASent from './components/TwoFASent.vue';
import VerifyTwoFA from './components/VerifyTwoFA.vue';
import IndividualContact2 from './components/dashboard/contacts/IndividualContact2.vue';
// import JDStatus from './components/dashboard/jobDescription/JDStatus.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        guest: true,
      },
    },
    {
      path: '/twofa-sent',
      name: 'TwoFASent',
      component: TwoFASent,
    },
    {
      path: '/verify-2fa',
      name: 'VerifyTwoFA',
      component: VerifyTwoFA,
      meta: {
        guest: true,
      },
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: Agreement,
      meta: {
        guest: true,
      },
    },
    {
      path: '/forgot',
      name: 'forgot-password',
      component: ForgotPassword,
      meta: {
        guest: true,
      },
    },
    {
      path: '/reset/:token',
      name: 'reset-password',
      component: ResetPassword,
      meta: {
        guest: true,
      },
    },
    {
      path: '/set/:token',
      name: 'set-password',
      component: SetPassword,
      meta: {
        guest: true,
      },
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        auth: true,
      },
    },
    // {
    //   path: '/users',
    //   name: 'users',
    //   component: Users,
    //   meta: {
    //     auth: true,
    //   },
    // },
    // {
    //   path: '/users/create',
    //   name: 'createUser',
    //   component: CreateUser,
    //   props: {isEditing: false},
    //   meta: {
    //     auth: true,
    //   },
    // },
    // {
    //   path: '/users/:id/edit',
    //   name: 'editUser',
    //   component: CreateUser,
    //   props: {isEditing: true},
    //   meta: {
    //     auth: true,
    //   },
    // },
    // {
    //   path: '/job-description-list',
    //   name: 'jd-menu',
    //   component: JobDescriptionList,
    //   meta: {
    //     auth: true,
    //   },
    // },
    // {
    //   path: '/job-matching-list/:id',
    //   name: 'jd-matching-list',
    //   component: JDMatchingList,
    //   meta: {
    //     auth: true,
    //   },
    // },
    // {
    //   path: '/job-matching/:id',
    //   name: 'jd-matching',
    //   component: JobMatching,
    //   meta: {
    //     auth: true,
    //   },
    // },
    {
      path: '/applicant/:applicantId/contact',
      name: 'individual-contact',
      component: IndividualContact2,
      meta: {
        auth: true,
      },
      props: true,
    },
    // {
    //   path: '/applicant/:applicantId/contact',
    //   name: 'individual-contact',
    //   component: IndividualContact,
    //   meta: {
    //     auth: true,
    //   },
    //   props: true,
    // },
    {
      path: '/message-template',
      name: 'message-template',
      component: MessageTemplate,
      meta: {
        auth: true,
      },
      props: true,
    },
    {
      path: '/message-template/create',
      name: 'createMessageTemplate',
      component: ModifyMessageTemplate,
      meta: {
        auth: true,
      },
    },
    {
      path: '/message-template/edit/:id',
      name: 'editMessageTemplate',
      component: ModifyMessageTemplate,
      meta: {
        auth: true,
      },
      props: true,
    },
    {
      path: '/contact-list',
      name: 'contact-list',
      component: ContactList,
      meta: {
        auth: true,
      },
      children: [
        {
          path: '/contact-list/received-list',
          name: 'received-list',
          component: ReceivedContactLists,
          meta: {
            auth: true,
          },
        },
        {
          path: '/contact-list/sent-list',
          name: 'sent-list',
          component: SentContactList,
          meta: {
            auth: true,
          },
        },
      ],
    },
    {
      path: '/setting',
      name: 'setting',
      component: Setting,
      meta: {
        auth: true,
      },
      children: [
        {
          path: '/setting/users',
          name: 'users',
          component: Users,
          meta: {
            auth: true,
          },
        },
        {
          path: '/setting/users/create',
          name: 'createUser',
          component: CreateUser,
          props: { isEditing: false },
          meta: {
            auth: true,
          },
        },
        {
          path: '/setting/users/:id/edit',
          name: 'editUser',
          component: CreateUser,
          props: { isEditing: true },
          meta: {
            auth: true,
          },
        },
        {
          path: '/setting/review-list',
          name: 'ReviewList',
          component: ReviewList,
          meta: {
            auth: true,
          },
        },
        {
          path: '/setting/review-list/create',
          name: 'createReviewList',
          component: CreateReviewList,
          props: { isEditing: false },
          meta: {
            auth: true,
          },
        },
        {
          path: '/setting/review-list/:id/edit',
          name: 'EditReviewList',
          component: CreateReviewList,
          props: { isEditing: true },
          meta: {
            auth: true,
          },
        },
        // {
        //   path: '/setting/occupation-list',
        //   name: 'OccupationList',
        //   component: OccupationList,
        //   meta: {
        //     auth: true,
        //   },
        // },
        {
          path: '/setting/change-password',
          name: 'ChangePassword',
          component: ChangePassword,
          meta: {
            auth: true,
          },
        },
        // {
        //   path: '/setting/jd-status',
        //   name: 'JD Status',
        //   component: JDStatus,
        //   meta: {
        //     auth: true
        //   }
        // }
      ],
    },
    // {
    //   path: '/setting/review-list',
    //   name: 'ReviewList',
    //   component: ReviewList,
    //   meta: {
    //     auth: true,
    //   },
    // },
    // {
    //   path: '/setting/review-list/create',
    //   name: 'createReviewList',
    //   component: CreateReviewList,
    //   props: {isEditing: false},
    //   meta: {
    //     auth: true,
    //   },
    // },
    // {
    //   path: '/setting/review-list/:id/edit',
    //   name: 'EditReviewList',
    //   component: CreateReviewList,
    //   props: {isEditing: true},
    //   meta: {
    //     auth: true,
    //   },
    // },
    {
      path: '/searchTemplate',
      name: 'search-template',
      component: SearchTemplates,
      meta: {
        auth: true,
      },
    },
    {
      path: '/applicant',
      name: 'applicant',
      component: Applicants,
      meta: {
        auth: true,
      },
    },
    {
      path: '/pending-applicants',
      name: 'pending-applicants',
      component: () => import('@/views/PendingReview.vue'),
      meta: {
        auth: true,
      },
    },
    {
      path: '/scout-applicant',
      name: 'scout-applicants',
      component: ScoutApplicants,
      meta: {
        auth: true,
      },
    },
    {
      path: '/applicant/:id/print',
      name: 'print-applicant-profile',
      component: PrintApplicantProfile,
      meta: {
        auth: true,
      },
    },
    {
      path: '/applicant/:id/view',
      name: 'view-applicant-profile',
      component: ViewApplicantProfile,
      meta: {
        auth: true,
      },
      props: true,
    },
    {
      path: '/preview-applicants/:id',
      name: 'preview-applicant',
      component: ApplicantPreview,
      meta: {
        auth: true,
      },
      props: true,
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout,
      meta: {
        auth: true,
      },
    },
    {
      path: '*',
      name: 'not-found',
      component: NotFound,
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  if (
    from.query.next &&
    AuthService.isLoggedIn() &&
    to.fullPath !== from.query.next &&
    from.query.next !== '/logout' &&
    (to.name === 'applicant' || to.name === 'home')
  ) {
    return router.push(from.query.next);
  }
  // if(to.meta.roles && to.meta.auth && !AuthService.hasRequiredRoles(to.meta.roles)){
  //   return router.push('/applicant');
  // }
  if (to.meta.guest && AuthService.isLoggedIn()) {
    return router.push(from.path === '/' ? '/applicant' : from.path);
  }
  if (to.meta.auth && !AuthService.isLoggedIn())
    return router.push(`/?next=${to.path}`);
  return next();
});

export default router;
